var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10C2.55228 10 3 10.4477 3 11V13H13V11C13 10.4477 13.4477 10 14 10C14.5523 10 15 10.4477 15 11V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V11C1 10.4477 1.44772 10 2 10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1C8.55228 1 9 1.44772 9 2V7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7V2C7 1.44772 7.44772 1 8 1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10C7 9.44772 7.44772 9 8 9C8.55228 9 9 9.44772 9 10C9 10.5523 8.55228 11 8 11C7.44772 11 7 10.5523 7 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSync);
export default __webpack_public_path__ + "static/media/Download-Sync.fedf3df80027388ac5b3b425e99b6445.svg";
export { ForwardRef as ReactComponent };